import 'angular-xeditable/dist/css/xeditable.css';
import 'angular-xeditable/dist/js/xeditable.js';

export default 'xeditable';
